<!-- Titel mit Ellipsis bei Überlauf und nativem Tooltip -->
<span class="title-text" [title]="data().title">
  {{ data().title }}
</span>
